import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import Translate, { translate } from './Translate';
import Icon from './Icon';
import { AccessibilityStore, TranslationStore } from '../stores';
import { Theme } from '../models/Theme';
import HeaderButton from './HeaderButton';
import { ClearFiltersOptions } from '../models/configuration/header/ClearFilters';

interface ClearFiltersButtonProps extends ClearFiltersOptions {
    theme?: Theme;
    translationStore?: TranslationStore;
    accessibilityStore?: AccessibilityStore;
    onClick: (event: MouseEvent) => void;
    filtersActive?: boolean;
    expanded?: boolean;
}

@inject('accessibilityStore', 'translationStore')
@observer
class ClearFiltersButton extends React.Component<ClearFiltersButtonProps> {
    constructor(props) {
        super(props);
    }

    handleButtonClick = (event: MouseEvent) => {
        const { filtersActive, onClick } = this.props;

        if (filtersActive) {
            onClick(event);
        }
    };

    render() {
        const {
            theme,
            translationStore,
            accessibilityStore,
            filtersActive,
            expanded,
            label = 'Clear Search & Filters',
            icon = { filename: 'CloseIcon', position: 'after' },
        } = this.props;

        return (
            <HeaderButton
                disabled={!filtersActive}
                aria-label={accessibilityStore.buttonAccessibilityValue(
                    'ClearFiltersButton'
                )}
                title={translate(translationStore, 'Filters')}
                onClick={this.handleButtonClick}
                data-metric-id={'clear-filters-button'}
                aria-expanded={expanded}
                aria-controls={'filters-mask'}
                {...theme.ClearFiltersButton}
            >
                <Icon
                    hide={icon.hide || icon.position !== 'before'}
                    fileName={icon.filename}
                    height="1.4em"
                    width="1.4em"
                    margin="0 0.5em 0 0"
                    {...theme.ClearFiltersButtonIcon}
                />
                <Translate>{label}</Translate>
                <Icon
                    hide={icon.hide || icon.position !== 'after'}
                    fileName={icon.filename}
                    height="1.4em"
                    width="1.4em"
                    margin="0 0.5em 0 0"
                    {...theme.ClearFiltersButtonIcon}
                />
            </HeaderButton>
        );
    }
}

export default withTheme(ClearFiltersButton) as any;



// WEBPACK FOOTER //
// ./src/Components/ClearFiltersButton.tsx